import { createContext } from "react";

type BaseDisplayContext = {
  usedBrowserHeight: number;
};

const defaultContext: BaseDisplayContext = {
  usedBrowserHeight: 0,
};

export const BaseDisplayContext =
  createContext<BaseDisplayContext>(defaultContext);

// ユーザーの利用ブラウザの状態保持
export const useDisplayData = (): BaseDisplayContext => {
  // 利用ブラウザの高さ
  const usedBrowserHeight = window.visualViewport
    ? window.visualViewport.height
    : 0;

  return {
    usedBrowserHeight,
  };
};
